import { RECEIVE_DATA_OBJECTS, STORE_DATA_OBJECTS } from '@inpart-io/devtools-vue';
import { type ILeadConsumerHealthProfile, type IPrivateConsumerHealthAsset } from '@inpart-io/padme-iap';
import { type ActionTree } from 'vuex';

import { isDataObject } from '@/services/data-object-helper';
import { PRIVATE_CONSUMER_HEALTH_ASSET_MODULE } from '@/store/private-consumer-health-asset-module';

export const actions: ActionTree<ILeadConsumerHealthProfile, unknown> = {
    [STORE_DATA_OBJECTS](context, { dataObjectList }: { dataObjectList: ILeadConsumerHealthProfile[] }) {
        const assetProfiles: ILeadConsumerHealthProfile[] = [];
        const assetEntities: IPrivateConsumerHealthAsset[] = [];

        dataObjectList.forEach((assetProfile) => {
            const _assetProfile = Object.assign({}, assetProfile);

            if (isDataObject<IPrivateConsumerHealthAsset>(assetProfile.assetEntity)) {
                const assetEntity = Object.assign({}, assetProfile.assetEntity);
                _assetProfile.assetEntity = assetEntity.dobjId;
                assetEntities.push(assetEntity);
            }

            assetProfiles.push(_assetProfile);
        });

        if (assetProfiles.length > 0) {
            context.commit(RECEIVE_DATA_OBJECTS, { dataObjectList: assetProfiles });
        }
        if (assetEntities.length > 0) {
            void context.dispatch(`${PRIVATE_CONSUMER_HEALTH_ASSET_MODULE}/${STORE_DATA_OBJECTS}`, { dataObjectList: assetEntities }, { root: true });
        }
    }
};
